var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMainSplitHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_main_split_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.764706 0 0 0 0 0.631373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_main_split_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "vertical_split_black_24dp-copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,15 L10,15 C10.55,15 11,14.55 11,14 C11,13.45 10.55,13 10,13 L4,13 C3.45,13 3,13.45 3,14 C3,14.55 3.45,15 4,15 Z M4,19 L10,19 C10.55,19 11,18.55 11,18 C11,17.45 10.55,17 10,17 L4,17 C3.45,17 3,17.45 3,18 C3,18.55 3.45,19 4,19 Z M4,11 L10,11 C10.55,11 11,10.55 11,10 C11,9.45 10.55,9 10,9 L4,9 C3.45,9 3,9.45 3,10 C3,10.55 3.45,11 4,11 Z M3,6 C3,6.55 3.45,7 4,7 L10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 L4,5 C3.45,5 3,5.45 3,6 Z M14,5 L20,5 C20.55,5 21,5.45 21,6 L21,18 C21,18.55 20.55,19 20,19 L14,19 C13.45,19 13,18.55 13,18 L13,6 C13,5.45 13.45,5 14,5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainSplitHover);
export default __webpack_public_path__ + "static/media/icon_main_split_hover.ecb09c3d83f7c03dfd12d55287a7ac6e.svg";
export { ForwardRef as ReactComponent };